$ = jQuery.noConflict()
$ ->
	init()

init = ->
	# Global JS
	App.init()

	# Sliders
	
	if $('[slick]').length
		Slider.init()

	# Maps
	if $('.gmap').length
		Maps.init()

	# Poi
	if $('#poi--list').length
		Poi.init()

	# Block Intro
	if $('.block-intro').length
		Intro.init()

	# Block Expérience Intro
	if $('.block-experience-intro').length
		ExperienceIntro.init() 
		
	# BLOCK TESTIMONIALS
	if $('.testimonials-container').length
		Testimonials.init()
		
	# BLOCK PRESS
	if $('.presse-container').length
		Press.init()
		
	#CUSTOM SELECT
	if $('.custom-select').length
		CustomSelect.init()
		
	if $('.help-choose-container').length
		HelpContainer.init()
		
	# Block Appartement
	if $('.block-appartement').length
		Appartement.init()

	# Block Services
	if $('.block-services').length
		Services.init()

	# Block Search Villa
	#if $('.block-search-villa').length
		#SearchVilla.init()
		
	if $('.region-select').length	
		TriListVilla.init()

	if $('.villa-content-wrapper').length
		VillaContent.init()
		
	if $(".actus--list").length
		ActusList.init();
		
	# Block Valeurs
	if $('.block-valeurs').length
		Valeurs.init()

	# Single article
	if $('.page-article .article-actu').length
		Article.init()

	# Block histoire (page ABout)
	if $('.block-histoire').length
		Histoire.init()

	# Home Mobile
	if Config.isMobile()
		if $('.home-mobile').length
			HomeMobile.init()

	# Liste villa
	if $('.page-liste-villas').length
		ListeVilla.init()

	# Villa
	if $('.block-intro_villa').length
		Villa.init()

destroy = ->
	App.destroy()
